import { useSelector } from 'react-redux';
import uzTranslations from './translations/uz.json';
import ruTranslations from './translations/ru.json';

const translations = {
  uz: uzTranslations,
  ru: ruTranslations
};

/**
 * Custom hook for translations
 * Gets language from Redux auth state or localStorage, defaults to 'uz'
 */
export const useTranslation = () => {
  const auth = useSelector(state => state.auth);
  
  // Get language from user preferences, localStorage, or default to 'uz'
  const getLanguage = () => {
    // Check if user has language preference
    if (auth?.user?.language) {
      return auth.user.language;
    }
    
    // Check localStorage
    const storedLang = localStorage.getItem('language');
    if (storedLang && (storedLang === 'uz' || storedLang === 'ru')) {
      return storedLang;
    }
    
    // Default to Uzbek
    return 'uz';
  };

  const language = getLanguage();
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Fallback to Uzbek if translation not found
        value = translations.uz;
        for (const fallbackKey of keys) {
          if (value && typeof value === 'object' && fallbackKey in value) {
            value = value[fallbackKey];
          } else {
            return key; // Return key if translation not found
          }
        }
        break;
      }
    }
    
    return typeof value === 'string' ? value : key;
  };

  return { t, language };
};

export default useTranslation;

